var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditopp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.532,
    height: 15.399,
    viewBox: "0 0 11.532 15.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M11.118,239.957a1.418,1.418,0,0,0-2,0l-1.025,1.025a2.322,2.322,0,0,0-4.643,0L2.42,239.957a1.418,1.418,0,0,0-2,2l2.967,2.967v1.512a.451.451,0,0,0,.451.451H7.7a.451.451,0,0,0,.451-.451v-1.512l2.967-2.967A1.419,1.419,0,0,0,11.118,239.957Zm-5.351-.383a1.42,1.42,0,1,1-1.42,1.42A1.421,1.421,0,0,1,5.766,239.574Zm4.713,1.749-3.1,3.1a.451.451,0,0,0-.132.319v1.248H4.285v-1.248a.451.451,0,0,0-.132-.319l-3.1-3.1a.515.515,0,0,1,.729-.729l2.589,2.589a.451.451,0,0,0,.319.132H6.843a.451.451,0,0,0,.319-.132l2.589-2.589a.515.515,0,1,1,.729.729Zm0,0",
    transform: "translate(0 -231.494)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M77.769,4.275,77.452,6.12a.451.451,0,0,0,.655.476l1.657-.871L81.42,6.6a.449.449,0,0,0,.21.052h0a.452.452,0,0,0,.439-.552l-.312-1.82L83.1,2.968a.451.451,0,0,0-.25-.77L81,1.93,80.168.251a.451.451,0,0,0-.809,0L78.531,1.93,76.679,2.2a.451.451,0,0,0-.25.77ZM78.9,2.789a.451.451,0,0,0,.34-.247l.529-1.071.529,1.071a.451.451,0,0,0,.34.247l1.182.172-.856.834a.451.451,0,0,0-.13.4l.2,1.177-1.057-.556a.45.45,0,0,0-.42,0L78.5,5.371l.2-1.177a.451.451,0,0,0-.13-.4l-.856-.834Zm0,0",
    transform: "translate(-73.997)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditopp);
export default __webpack_public_path__ + "static/media/editopp.da3dd19b28e74ff129a2957fc76afcb7.svg";
export { ForwardRef as ReactComponent };